import { FormikErrors } from 'formik';

export function getFormikError<T = unknown>(
    error: string | string[] | FormikErrors<T>[] | FormikErrors<T> | undefined
): string | undefined {
    if (!error) {
        return undefined;
    }
    if (typeof error === 'string') {
        return error;
    }
    if (Array.isArray(error)) {
        const strings = error.filter((e): e is string => typeof e === 'string');
        return strings.length > 0 ? strings.join(', ') : undefined;
    }
    return undefined;
}
